import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import get from 'lodash/get'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import Section from '../../common/Section/Section'
import Theme from '../../../vars/ThemeOptions'
 

const Styled = {}
Styled.Wrap = styled.div`
  position: relative;
  top: -7rem;
  // overflow: hidden;
  margin-bottom: 0;
  @media only screen and (max-width: 991px) {
    padding-top: 18rem;
  }
`
Styled.ContentCol = styled(Col)`
  color: white;
  b {
    color: ${Theme.hex('primary')} !important;
  }
  ul {
    margin-bottom: 2rem;
    li {
      p {
        margin-top: -25px;
      }
    }
    li::before {
      content: '\\2022';
      color: ${Theme.hex('primary')} !important;
      font-weight: bold;
      font-size: 1.5rem;
      display: inline-block;
      width: 1em;
      margin-left: -20px;
      margin-top: -20px;
      margin-bottom: -3px;
    }
  }
  h6 {
    margin-top: 2rem;
    b {
      font-size: 1.5rem;
      color: ${Theme.hex('white')} !important;
    }
  }
  blockquote {
    margin: 1rem 0 1.5rem;
    a {
      display: block;
      background: ${Theme.hex('primary')};
      width: 16.5rem;
      padding: .5rem 0;
      color: ${Theme.hex('white')};
      font-weight: bold;
      text-align: center;
      transform: scale(1);
      transition: all .3s ease;
      :hover {
        transform: scale(1.1);
        transition: all .3s ease;
      }
    }
  }
  a:hover {
    text-decoration: none;
  }
  @media only screen and (max-width: 991px) {
    color: ${Theme.hex('darkGray')};
  }
  @media only screen and (max-width: 525px) {
    margin-top: 1.75rem;
  }
`
Styled.FormButton = styled.button`
  border: none;
  margin-bottom: 1.5rem;
  background: ${Theme.hex('primary')};
  width: 17rem;
  padding: .5rem 3rem;
  color: ${Theme.hex('white')};
  font-weight: bold;
  transform: scale(1);
  transition: all .3s ease;
  :hover {
    transform: scale(1.1);
    transition: all .3s ease;
  }
`
Styled.BgImageWrap = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: -30vw;
  width: 130vw;
  height: 150%;
  background-image: url(${({ bgUrl }) => bgUrl ? bgUrl : ""});
  background-size: cover;
  background-position: center center;
  // img {
  //   width: 100%;
  //   height: 100%;
  // }
  .bg-fade {
    position: absolute;
    top: 0;
    left: 30vw;
    width: 100vw;
    height: 150%;
    background: linear-gradient(to right, rgba(19,24,47,1) 0%, rgba(19,24,47,0.7) 100%);
  }
  @media only screen and (max-width: 991px) {
    left: 0;
    width: 100vw;
    height: 30rem;
    background-position: top right;
    .bg-fade {
      left: 0;
      height: 100%;
      background: linear-gradient(45deg, rgba(19,24,47,1) 0%, rgba(19,24,47,0.2) 100%);
    }
  }
  @media only screen and (max-width: 525px) {
    height: 32.5rem;
  }
`
 
const MagazineLP = ({ slug }) => {
  const allData = useStaticQuery(query)
  const data = slug === "5280" ? allData.default : allData.noco
  // console.log('data from LPfor5280Ad: ', data);
  const content = get(data, "richText1")
  const bgImgFile = get(data.fileRef, "file")
  const bgImgUrl = get(bgImgFile, "url")
  //const bgImgTitle = get(bgImgFile, "title")

  return (
    <Styled.Wrap>
      <Section data={data} noBgImage bgFade padding="7rem 0 0 0" mobTitleColor={Theme.hex('white')}>
        <Container fluid>
          <Row>
            <Styled.ContentCol lg={8} md={12}>
              {content && documentToReactComponents(content.json)}
            </Styled.ContentCol>
          </Row>
        </Container>
      </Section>
      <Styled.BgImageWrap bgUrl={bgImgUrl}>
        {/* <img src={bgImgUrl} alt={bgImgTitle} /> */}
        <div className="bg-fade" />
      </Styled.BgImageWrap>
    </Styled.Wrap>
  )
}
 
export default MagazineLP


const query = graphql`
  query {
    default: contentfulGlobal(title: {eq: "Home Is Where The Heart Is..."}) {
      ...NodeGlobalFields
    }
    noco: contentfulGlobal(title: {eq: "Home Is Where The Heart Is..."}, shortText1: {eq: "noco"}) {
      ...NodeGlobalFields
    }
  }
`